import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import Main from "./components/Main";
import Navbar from "./components/Navbar";
import CreatePage from "./pages/CreatePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import HomePage from "./pages/HomePage";
import LogInPage from "./pages/LogInPage";
import ProfilePage from "./pages/ProfilePage";
import SignUpPage from "./pages/SignUpPage";
import ErrorPage from "./pages/ErrorPage";
import CheckEmailPage from "./pages/CheckEmailPage";
import CreatePasswordPage from "./pages/CreatePasswordPage";
import ClosedPage from "./pages/Prospects/ClosedPage";
import ContactedPage from "./pages/Prospects/ContactedPage";
import InactivePage from "./pages/Prospects/InactivePage";
import NegotiationPage from "./pages/Prospects/NegotiationPage";
import PendingVisitsPage from "./pages/Prospects/PendingVisitsPage";
import WinPage from "./pages/Prospects/WinPage";
import CreateModal from "./components/modals/CreateModal";
import CompletedTasks from "./pages/TasksPage/CompletedTasks";
import CreateTask from "./pages/TasksPage/CreateTask";
import TodayTasks from "./pages/TasksPage/TodayTasks";
import UpcomingTasks from "./pages/TasksPage/UpcomingTasks.jsx";
import AllTasks from "./pages/TasksPage/AllTasks.jsx";
import SubscriptionPackages from "./pages/SubscriptionPackages.jsx";
import CustomerHistory from "./pages/CustomerHistory.jsx";
import ExhibitionUserList from "./pages/ExhibitionUserList.jsx";
import ExhibitionDetails from "./pages/ExhibitionDetails.jsx";
import ExhibitionUserRedirectPage from "./pages/ExhibitionUserRedirectPage.jsx";
import ExhibitionPage from "./pages/ExhibitionPage.jsx";
import Theme from "./pages/Profile/Theme.jsx";
import Fonts from "./pages/Profile/Fonts.jsx";
import Language from "./pages/Profile/Language.jsx";
import PushNotification from "./pages/Profile/PushNotification.jsx";
import SMSGetaway from "./pages/Profile/SMSGetaway.jsx";
import EmailSetup from "./pages/Profile/EmailSetup.jsx";
import Configuration from "./pages/Profile/Configuration.jsx";
import CreateSMSGetaway from "./pages/Profile/CreateSMSGetaway.jsx";
import SmsTemplate from "./pages/Profile/SmsTemplate.jsx";
import CreateEmail from "./pages/Profile/CreateEmail.jsx";
import EmailTemplate from "./pages/Profile/EmailTemplate.jsx";
import StatusVertical from "./pages/Profile/StatusVertical.jsx";
import AdminDashboard from "./pages/Admin/AdminDashboard.jsx";
import AdminTasks from "./pages/Admin/AdminTasks.jsx";
import AdminExhibition from "./pages/Admin/AdminExhibition.jsx";
import Sidebar from "./pages/Admin/AdminComponents/Sidebar";
import AdminCreate from "./pages/Admin/AdminCreate.jsx";
import AdminProfile from "./pages/Admin/AdminProfile.jsx";
import AdminCreateModal from "./pages/Admin/AdminComponents/AdminCreateModal.jsx";
import AdminCreateTask from "./pages/Admin/AdminCreateTask.jsx";
import AdminCustomerHistory from "./pages/Admin/AdminCustomerHistory.jsx";
import AdminSubscription from "./pages/Admin/AdminSubscription.jsx";
import AdminSocialMedia from "./pages/Admin/AdminSocialMedia.jsx";
import Subscription from "./pages/Subscription.jsx";
import SocialMedia from "./pages/SocialMedia.jsx";
import RenewSubscribePackage from "./components/RenewSubscribePackage.jsx";
import CurrentSubscribePackage from "./components/CurrentSubscribePackage.jsx";
import Cancellation from "./pages/Cancellation.jsx";
import Refund from "./pages/Refund.jsx";
import TrackRefund from "./pages/TrackRefund.jsx";
import SuperAdminDashboard from "./pages/SuperAdmin/SuperAdminDashboard.jsx";
import SuperAdminSidebar from "./pages/SuperAdmin/Components/SuperAdminSidebar.jsx";
import SupportTickets from "./pages/SuperAdmin/SupportTickets.jsx";
import AppDetails from "./pages/SuperAdmin/AppDetails.jsx";
import PaymentDetails from "./pages/SuperAdmin/PaymentDetails.jsx";
import ServeProcessingDetails from "./pages/SuperAdmin/ServeProcessingDetails.jsx";
import SubscriptionHistory from "./pages/SuperAdmin/SubscriptionHistory.jsx";
import ReportSegment from "./pages/ReportSegment.jsx";
import AdminReportSegment from "./pages/Admin/AdminReportSegment.jsx";
import SelectEmailTemplate from "./pages/Profile/SelectEmailTemplate.jsx";
import Support from "./pages/Support.jsx";
import AdminSupport from "./pages/Admin/AdminSupport.jsx";
import ServerProcessing from "./pages/ServerProcessing.jsx";
import AdminServerProcessing from "./pages/Admin/AdminServerProcessing.jsx";
import LandingPage from "./pages/website/LandingPage.jsx";

const ValidationPage = () => {
  return (
    <div className="flex flex-row w-full justify-center ">
      <div className="flex justify-center w-6/12 validation-outlet">
        <Outlet />
      </div>
      <div className="w-6/12 main-desktop-img">
        <Main />
      </div>
    </div>
  );
};

const DashboardPage = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const CreateScreen = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const TaskScreen = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};
const ExhibitionRoutes = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const ProfileRoutes = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const SubscriptionRoutes = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const SocialMediaIntegration = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const Report = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const HelpAndSupport = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const ServerProcessingTime = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Navbar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const AdminDashBoard = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <Sidebar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const SuperAdmin = () => {
  return (
    <div className="flex flex-row ">
      <div className="w-2/12 navbar">
        <SuperAdminSidebar />
      </div>
      <div className="w-10/12 bg-white dashboard">
        <Outlet />
      </div>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <ValidationPage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <LogInPage />,
      },
      {
        path: "/signup",
        element: <SignUpPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/check-email",
        element: <CheckEmailPage />,
      },
      {
        path: "/create-password",
        element: <CreatePasswordPage />,
      },
    ],
  },
  {
    path: "/clear-result",
    element: <LandingPage />,
  },
  {
    path: "/subscriptions",
    element: <SubscriptionPackages />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
    children: [
      {
        path: "/dashboard",
        element: <HomePage />,
      },

      {
        path: "/dashboard/prospects",
        element: <ContactedPage />,
      },
      {
        path: "/dashboard/prospects/pending-visits",
        element: <PendingVisitsPage />,
      },
      {
        path: "/dashboard/prospects/negotiation",
        element: <NegotiationPage />,
      },
      {
        path: "/dashboard/prospects/inactive",
        element: <InactivePage />,
      },
      {
        path: "/dashboard/prospects/win",
        element: <WinPage />,
      },
      {
        path: "/dashboard/prospects/closed",
        element: <ClosedPage />,
      },
    ],
  },
  {
    path: "/create",
    element: <CreateScreen />,
    children: [
      {
        path: "/create",
        element: <CreatePage />,
      },
      {
        path: "/create/select",
        element: <CreateModal />,
      },
    ],
  },
  {
    path: "/tasks",
    element: <TaskScreen />,
    children: [
      {
        path: "/tasks",
        element: <TodayTasks />,
      },
      {
        path: "/tasks/upcoming",
        element: <UpcomingTasks />,
      },
      {
        path: "/tasks/completed",
        element: <CompletedTasks />,
      },
      {
        path: "/tasks/all",
        element: <AllTasks />,
      },
      {
        path: "/tasks/create-task",
        element: <CreateTask />,
      },
      {
        path: "/tasks/customer-history",
        element: <CustomerHistory />,
      },
    ],
  },
  {
    path: "/exhibition",
    element: <ExhibitionRoutes />,
    children: [
      {
        path: "/exhibition",
        element: <ExhibitionPage />,
      },
      {
        path: "/exhibition/exhibitionUserList",
        element: <ExhibitionUserList />,
      },
      {
        path: "/exhibition/exhibitionDetails",
        element: <ExhibitionDetails />,
      },
      {
        path: "/exhibition/exhibitionUserRedirectPage",
        element: <ExhibitionUserRedirectPage />,
      },
    ],
  },
  {
    path: "/profile",
    element: <ProfileRoutes />,
    children: [
      {
        path: "/profile",
        element: <ProfilePage />,
      },
      {
        path: "/profile/theme",
        element: <Theme />,
      },
      {
        path: "/profile/fonts",
        element: <Fonts />,
      },
      {
        path: "/profile/language",
        element: <Language />,
      },
      {
        path: "/profile/notifications",
        element: <PushNotification />,
      },
      {
        path: "/profile/sms",
        element: <SMSGetaway />,
      },
      {
        path: "/profile/email",
        element: <EmailSetup />,
      },
      {
        path: "/profile/configuration",
        element: <Configuration />,
      },
      {
        path: "/profile/create-sms-getaway",
        element: <CreateSMSGetaway />,
      },
      {
        path: "/profile/sms-template",
        element: <SmsTemplate />,
      },
      {
        path: "/profile/select-template",
        element: <SelectEmailTemplate />,
      },
      {
        path: "/profile/create-email",
        element: <CreateEmail />,
      },
      {
        path: "/profile/email-template",
        element: <EmailTemplate />,
      },
      {
        path: "/profile/status-vertical",
        element: <StatusVertical />,
      },
    ],
  },
  {
    path: "/subscriptions-models",
    element: <SubscriptionRoutes />,
    children: [
      {
        path: "/subscriptions-models",
        element: <Subscription />,
      },
      {
        path: "/subscriptions-models/renew",
        element: <RenewSubscribePackage />,
      },
      {
        path: "/subscriptions-models/current-package",
        element: <CurrentSubscribePackage />,
      },
      {
        path: "/subscriptions-models/cancellation",
        element: <Cancellation />,
      },
      {
        path: "/subscriptions-models/refund",
        element: <Refund />,
      },
      {
        path: "/subscriptions-models/track-refund",
        element: <TrackRefund />,
      },
    ],
  },
  {
    path: "/socials",
    element: <SocialMediaIntegration />,
    children: [
      {
        path: "/socials",
        element: <SocialMedia />,
      },
    ],
  },
  {
    path: "/report",
    element: <Report />,
    children: [
      {
        path: "/report",
        element: <ReportSegment />,
      },
    ],
  },

  {
    path: "/help-support",
    element: <HelpAndSupport />,
    children: [
      {
        path: "/help-support",
        element: <Support />,
      },
    ],
  },
  {
    path: "/server-processing",
    element: <ServerProcessingTime />,
    children: [
      {
        path: "/server-processing",
        element: <ServerProcessing />,
      },
    ],
  },

  // Admin DashBoard Flow
  {
    path: "/admin",
    element: <AdminDashBoard />,
    children: [
      {
        path: "/admin",
        element: <AdminDashboard />,
      },
      {
        path: "/admin/create/select",
        element: <AdminCreateModal />,
      },
      {
        path: "/admin/create",
        element: <AdminCreate />,
      },
      {
        path: "/admin/tasks",
        element: <AdminTasks />,
      },
      {
        path: "/admin/tasks/create-task",
        element: <AdminCreateTask />,
      },
      {
        path: "/admin/tasks/customer-history",
        element: <AdminCustomerHistory />,
      },
      {
        path: "/admin/exhibition",
        element: <AdminExhibition />,
      },
      {
        path: "/admin/profile",
        element: <AdminProfile />,
      },
      {
        path: "/admin/subscriptions",
        element: <AdminSubscription />,
      },
      {
        path: "/admin/social-media-integration",
        element: <AdminSocialMedia />,
      },
      {
        path: "/admin/report",
        element: <AdminReportSegment />,
      },
      {
        path: "/admin/support",
        element: <AdminSupport />,
      },
      {
        path: "/admin/server-processing",
        element: <AdminServerProcessing />,
      },
    ],
  },
  {
    path: "/super-admin",
    element: <SuperAdmin />,
    children: [
      {
        path: "/super-admin",
        element: <SuperAdminDashboard />,
      },
      {
        path: "/super-admin/support-ticket",
        element: <SupportTickets />,
      },
      {
        path: "/super-admin/app-details",
        element: <AppDetails />,
      },
      {
        path: "/super-admin/payment-details",
        element: <PaymentDetails />,
      },
      {
        path: "/super-admin/serve-processing-details",
        element: <ServeProcessingDetails />,
      },
      {
        path: "/super-admin/subscription-history",
        element: <SubscriptionHistory />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
